<script setup>

import {ErrorMessage, Field, Form} from 'vee-validate'
import {reactive, ref} from 'vue'
import axios from 'axios'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors } = useFormSubmit()
const schema = {
  name: 'required',
  email: 'required|email',
  phone_number: 'required|phoneNumber',
}

const confirmation = reactive({show: false, message: '', class: ''})
let isSubmitting = ref(false)

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('declutteringForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post('/submit-free-consult-form', formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg

      setTimeout(function () {
        confirmation.show = false;
      }, 4000);
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}
</script>

<template>
  <Form
    :validation-schema="schema"
    v-slot="{ errors }"
    @submit="onSubmit"
    id="declutteringForm"
    class="bg-pickled-bluewood-dark pt-8 pl-4 pr-4 pb-6 color-white"
  >
    <slot name="token"></slot>
    <h3 class="text-left fs-20 mt-0 mb-0">Book a free consult</h3>
    <p class="font-italic fs-15">
      To find out more about how Katie and the team at Moving On can support you through the
      process of downsizing, book a free consult.
    </p>
    <div class="form-group form-group--input">
      <label for="name" class="sr-only">Name</label>
      <Field
        id="name"
        name="name"
        class="form-control form-control--bg-white fs-14 ph-14"
        :class="{'is-danger': errors['name'] }"
        placeholder="Name *"
      />
      <ErrorMessage name="name" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="email" class="sr-only">Email</label>
      <Field
        id="email"
        name="email"
        class="form-control form-control--bg-white fs-14 ph-14"
        :class="{'is-danger': errors['email'] }"
        placeholder="Email *"
      />
      <ErrorMessage name="email" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="phone_number" class="sr-only">Phone</label>
      <Field
        id="phone_number"
        name="phone_number"
        class="form-control form-control--bg-white fs-14 ph-14"
        placeholder="Phone *"
        :class="{'is-danger': errors['phone_number'] }"
      />
      <ErrorMessage name="phone_number" class="is-danger" />
    </div>
    <div class="form-group form-group--input">
      <label for="message" class="sr-only">Message</label>
      <textarea
        id="message"
        placeholder="I'd like to learn more about the services that Moving On offers"
        rows="2"
        class="form-control form-control--bg-white fs-14 ph-14"
        name="message"
        autocomplete="off"
      ></textarea>
    </div>
    <input type="hidden" name="captcha_action" value="agent_form">
    <transition name="fade">
      <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
    </transition>
    <div class="form-group mt-2 mb-0">
      <button type="submit" class="btn btn--green btn--auto-width btn--send submit fs-16 mb-0 pt-3 pb-2">
        Send
      </button>
    </div>
    <slot name="googlerecaptchatext"></slot>
  </Form>
</template>
